import { uiActions } from '@/lib/stores/ui'
import { Media } from '@/components/Media'
import { getCollectionId, getCollectionImages, getCollectionSummary, getCollectionTitle } from '@/queries/collections.tsx'
import { NDKEvent } from '@nostr-dev-kit/ndk'
import { Link, useLocation } from '@tanstack/react-router'
import { UserCard } from './UserCard'
import { cn } from '@/lib/utils'

export function CollectionCard({ collection, className }: { collection: NDKEvent } & React.HTMLAttributes<HTMLDivElement>) {
	const title = getCollectionTitle(collection)
	const collectionId = getCollectionId(collection)
	const pubkey = collection.pubkey
	const summary = getCollectionSummary(collection)
	const images = getCollectionImages(collection)
	const location = useLocation()

	const handleCollectionClick = () => {
		// Store the current path as the source path
		// This will also store it as originalResultsPath if not already set
		uiActions.setCollectionSourcePath(location.pathname)
	}
	return (
		<div className={cn('border border-zinc-800 rounded-lg bg-white shadow-sm flex flex-col', className)} data-testid="product-card">
			{/* Square aspect ratio container for image */}
			<Link
				to={`/collection/${collectionId}`}
				className="relative aspect-square overflow-hidden border-b border-zinc-800 block"
				onClick={handleCollectionClick}
			>
				{images && images.length > 0 ? (
					<Media
						src={images[0][1]}
						alt={title}
						className="w-full h-full object-cover rounded-t-[calc(var(--radius)-1px)] hover:scale-105 transition-transform duration-200"
					/>
				) : (
					<div className="w-full h-full bg-gray-100 flex items-center justify-center text-gray-400 rounded-lg hover:bg-gray-200 transition-colors duration-200">
						No image
					</div>
				)}
			</Link>

			<div className="p-4 flex flex-col gap-2 flex-grow">
				{/* Product title */}
				<Link to={`/collection/${collectionId}`} onClick={handleCollectionClick}>
					<h2 className="text-lg font-black border-b border-[var(--light-gray)] pb-2 overflow-hidden text-ellipsis whitespace-nowrap">
						{title}
					</h2>
					<div className="text-md font-medium">{summary}</div>
				</Link>

				{/* Add a flex spacer to push the collection author to the bottom */}
				<div className="flex-grow"></div>
				<div className="text-sm flex flex-row items-center gap-2">
					by <UserCard pubkey={pubkey} size="xs" />
				</div>
			</div>
		</div>
	)
}
